import type { MetricFilter } from "../types/core"
import {
  getWidgetMetricOutputType,
  isWidgetMetricOutputType,
} from "./widgetMetricOutputType"

type FilterMetricDefinition = Parameters<typeof getWidgetMetricOutputType>[0]

export function getWidgetMetricFilters(
  value: MetricFilter | MetricFilter[] | undefined,
): MetricFilter[] | undefined {
  return value && !Array.isArray(value) ? [value] : value
}

/** A saved predicate needs review before a changed definition can reinterpret it. */
export function getWidgetMetricFilterError(
  filters: MetricFilter | MetricFilter[] | undefined,
  definitions: Record<string, FilterMetricDefinition>,
): string | null {
  for (const [index, filter] of (
    getWidgetMetricFilters(filters) ?? []
  ).entries()) {
    const label = `Metric filter ${index + 1}`
    if (!filter.metricId) {
      return `Choose a metric for filter ${index + 1}.`
    }
    const definition = definitions[filter.metricId]
    if (!definition) {
      return `${label}'s definition is unavailable. Retry loading metrics or edit the widget to remove the condition.`
    }
    const type = getWidgetMetricOutputType(definition)
    if (!isWidgetMetricOutputType(type)) {
      return `${label} uses an unsupported output type. Edit the widget to replace or remove the condition.`
    }
    if (type !== filter.metricOutputType) {
      return `${label}'s output type has changed to ${type}. Edit the widget and review its operator and value before saving.`
    }
    if (
      type === "float" &&
      (typeof filter.value !== "number" || !Number.isFinite(filter.value))
    ) {
      return `${label} requires a finite numeric value. Edit the widget to review its value before saving.`
    }
    if (type === "string" && !["=", "!="].includes(filter.operator)) {
      return `${label} requires = or ≠ for a string metric. Edit the widget to choose a supported operator.`
    }
  }
  return null
}
